export const BANNER_NAME_SO_FAR = 'orluna-so-far';
export const BANNER_NAME_WIDER = 'wider';
export const BANNER_NAME_IMAGE_ONLY = 'bg-image';
export const BANNER_NAME_GET_IN_TOUCH = 'get-in-touch';
export const BANNER_NAME_GET_IN_TOUCH_HOME = 'get-in-touch-home';
export const BANNER_NAME_GET_IN_TOUCH_SUSTAINABILITY =
  'get-in-touch-sustainability';
export const BANNER_NAME_VERTICAL_COPY = 'vertical-copy';
export const BANNER_NAME_NEED_REPAIRS = 'need-repairs';
